import LivestreamingEndedBanner from 'components/shared/LivestreamingEndedBanner/LivestreamingEndedBanner';
import LocationAdapter from 'shared/location_adapter';

export default class Index {
  constructor() {
    this.livestreaming_ended_banner = new LivestreamingEndedBanner();
    this._player_disposed = false;
  }

  run(livestreaming_status) {
    this._livestreaming_status = livestreaming_status;

    if (livestreaming_status.published === false) {
      return this.handleLivestreamingEndedBanner();
    }

    if (livestreaming_status.stream_right === false) {
      return this.handleBlockingBanner(livestreaming_status);
    }
  }

  handleLivestreamingEndedBanner() {
    if (this.livestreaming_ended_banner.shouldInit()) {
      this.livestreaming_ended_banner.init();
      this.livestreaming_ended_banner.show();
    }
  }

  handleBlockingBanner() {
    this.handleDisposePlayer();
    this.container = document.querySelector('.livestreaming-player');
    const blocking_banner = this.getBlockingBanner();
    this.container.appendChild(blocking_banner);
  }

  getBlockingBanner() {
    const image = document.createElement('img');
    image.src = this._livestreaming_status.blocking_banner_image_url;
    image.style.width = '100%';
    image.style.height = '100%';
    image.style.objectFit = 'cover';
    image.style.position = 'absolute';
    image.style.top = 0;
    image.style.left = 0;
    image.onload = () => {
      this.handleRedirection();
    };
    return image;
  }

  handleRedirection() {
    const { blocking_banner_url, blocking_banner_redirect_delay } = this._livestreaming_status;

    if (blocking_banner_url) {
      window.setTimeout(() => {
        LocationAdapter.href(blocking_banner_url);
      }, blocking_banner_redirect_delay * 1000);
    }
  }

  handleDisposePlayer() {
    if (window.player && !this._player_disposed) {
      window.player.dispose();
      this._player_disposed = true;
    }
  }
}
